import { Component } from '@angular/core';
import { ToastController } from 'ionic-angular';
import { NavController } from 'ionic-angular';
import { LoginService } from '../../providers/login';
import { ChampionshipService, Championship } from '../../providers/championship';
import { HomePage } from '../home/home';
import { LoginResult } from '../../entities/loginResult';
import { LocalStorageService } from '../../providers/localstorage';
import { LastLogin } from '../../entities/lastLogin';
import { Variables } from '../../providers/variables';
/*
declare function Teste();
declare var fingerprint;
declare function encryptData(data): any;
declare function decrypt(data): any;
*/

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})

export class LoginPage {

  ShowTab: number = 1;
  /*SignUpData: any = {
    UserName: "uira",
    Password: "utl016679"
  };  

  CreateData: any = {
    UserName: "uira",
    Password: "1234",
    ConfirmPassword: "1234",
    Email: "uiralima@gmail.com",
    ConfirmEmail: "uiralima@gmail.com"
  };
  
  CodeGenerateDate: any = {
    Email: "uiralima@gmail.com"
  };*/

  SignUpData: any = {
    UserName: "",
    Password: "",
    SavePassword: true
  };

  CreateData: any = {
    UserName: "",
    Password: "",
    ConfirmPassword: "",
    Email: "",
    ConfirmEmail: ""
  };

  CodeGenerateDate: any = {
    Email: ""
  };

  CodeData: any = {
    Email: "",
    Code: "",
    Password: "",
    ConfirmPassword: ""
  };

  public CommandButtonEnabled: boolean;

  public Title: string = "Bolão da Geral";

  User: any;
  

  constructor(public navCtrl: NavController, public loginService: LoginService, public toastCtrl: ToastController, 
    public championshipService: ChampionshipService, public localStorage: LocalStorageService) {
    /*Teste();
    alert(fingerprint);
    var ef = encryptData(fingerprint)
    alert(ef);
    alert(decrypt(ef));*/
    //super(navCtrl);
    this.ShowTab = 1;
    this.CommandButtonEnabled = true;
    try {
      var lastLogin: LastLogin = <LastLogin>JSON.parse(this.localStorage.getItem("lastLogin"));
      if ((null != lastLogin) && (undefined != lastLogin)) {
        this.SignUpData.SavePassword = lastLogin.AutoLogin;
        this.SignUpData.UserName = lastLogin.UserName;
        this.SignUpData.Password = lastLogin.Password;
        if ((lastLogin.AutoLogin) && (lastLogin.Password.length > 0)) {
          this.login();
        }
      }
    }
    catch {
      this.localStorage.removeItem("lastLogin");
    }
  }

  getTitle(complement: string = "") {
    return this.Title + ' ' + complement + ' v' + Variables.version;
}

  presentToast(message: string) {
    const toast = this.toastCtrl.create({
      message: message,
      duration: 10000,
      showCloseButton: true,
      closeButtonText: "Ok",
      position: 'middle'
    });
    toast.present();
}

getChampionships() {
  this.championshipService.getOpened().then((items: Championship[]) => {
    this.localStorage.setItem("championships", JSON.stringify(items));
    this.navCtrl.push(HomePage);
  }).catch((err) => {
    this.presentToast(err.Message);
})
};

login() {
    this.CommandButtonEnabled = false;
    this.loginService.login(this.SignUpData.UserName, this.SignUpData.Password, this.SignUpData.SavePassword).then((data) => {
      this.CommandButtonEnabled = true;
      var result = <LoginResult>data;
      if (result.Success) {
        this.getChampionships();
        //this.location.go("home.html");
      }
      else {
        this.presentToast(result.Message);
      }
    }).catch((err) => {
      this.CommandButtonEnabled = true;
      this.presentToast(err.Message);
    });
  }

  create() {
    this.CommandButtonEnabled = false;
    if (this.CreateData.Email.toUpperCase() != this.CreateData.ConfirmEmail.toUpperCase()) {
      this.presentToast("Os campos 'Email' e 'Confirma Email' devem ser iguais!");
      this.CommandButtonEnabled = true;
      return;
    }
    if (this.CreateData.Password != this.CreateData.ConfirmPassword) {
      this.presentToast("Os campos 'Senha' e 'Confirma Senha' devem ser iguais!");
      this.CommandButtonEnabled = true;
      return;
    }
    if (this.CreateData.Password.length < 4) {
      this.presentToast("O campo 'Senha' deve ter no mínimo 4 caracteres!");
      this.CommandButtonEnabled = true;
      return;
    }
    this.loginService.create(this.CreateData.UserName, this.CreateData.Email, this.CreateData.Password).then(() => {
      this.CommandButtonEnabled = true;
      this.presentToast("Bem Vindo ao Bolão da Geral " + this.CreateData.UserName);
      this.SignUpData.UserName = this.CreateData.UserName;
      this.SignUpData.Password = this.CreateData.Password;
      this.login();
    }).catch((err) => {
      this.CommandButtonEnabled = true;
      this.presentToast(err.Message);
    });
  }

  signUp() {
    this.ShowTab = 2;
  }

  forgetPassword() {
    this.ShowTab = 3;
  }

  codeGenerate() {
    this.CommandButtonEnabled = false;
    this.loginService.passwordRecoveryStarteate(this.CodeGenerateDate.Email).then(() => {
      this.CommandButtonEnabled = true;
      this.presentToast("Foi enviado um email com o código para gerar senha para o email " + this.CodeGenerateDate.Email);
      this.CodeData.Email = this.CodeGenerateDate.Email;
      this.ShowTab = 4;
    }).catch((err) => {
      this.CommandButtonEnabled = true;
      this.presentToast(err.Message);
    });
  }

  changePassword() {
    this.CommandButtonEnabled = false;
    if (this.CodeData.Password != this.CodeData.ConfirmPassword) {
      this.presentToast("Os campos 'Senha' e 'Confirma Senha' devem ser iguais!");
      this.CommandButtonEnabled = true;
      return;
    }
    if (this.CodeData.Password.length < 4) {
      this.presentToast("O campo 'Senha' deve ter no mínimo 4 caracteres!");
      this.CommandButtonEnabled = true;
      return;
    }
    this.loginService.changePasswordByCode(this.CodeData.Email, this.CodeData.Code, this.CodeData.Password).then(() => {
      this.CommandButtonEnabled = true;
      this.presentToast("Senha alterada !");
      this.ShowTab = 1;
    }).catch((err) => {
      this.CommandButtonEnabled = true;
      this.presentToast(err.Message);
    });
  }

  goToCodePage() {
    this.ShowTab = 4;
  }

  goToStart() {
    this.ShowTab = 1;
  }

}


// WEBPACK FOOTER //
// ./src/pages/login/login.ts